export default __webpack_public_path__ + "static/media/gear-icon.54759859.png";